class RateError extends Error {
  constructor(msg, info, action = null) {
    super(msg);
    this.info = info;
    this.action = action;
  }
}

export default RateError;
